import { AuthType, UserRoles } from '../api';
import { tvbar } from '../hub/context';
import { Entity, LanguageType, NamedEntity, PageOut } from './misc';
import { DurationType, PaymentServiceType, UserPlan } from './plans';
import { TickerAssetType, UserTickerInfo } from './tickers';

export enum TickerSmcType {
    Any,
    WithSmc,
    WithoutSmc
}
export enum ServerAction {
    Restart
}
export enum ChangeTickersStatusType {
    All,
    Smc
}
export enum UserExpType {
    Append,
    FromNow,
    Set
}
export interface LogEntry {
    at: number;
    msg: string;
}
export interface ClipDataOut {
    bars: tvbar[];
    at: number;
}
export interface UpdateUserIn {
    id: number;
    login?: string;
    pwd?: string;
    active?: boolean;
    authType?: AuthType;
    roles?: UserRoles;
    comment?: string;
    promo?: string;
    parentId?: number;
    planId?: number;
    //tickers?: number;
    //setups?: number;
   //extra?: UserPlanExtra;
    maxSessions?: number;
   // scopeId?: ScopeIds;
    domain?: string;
    rate?: number;
}

export interface User extends UpdateUserIn {
    createdAt: number;
    expiresAt: number;
    sessions: number;
    telegaChatId?: number;
    geo?: string;
    uId?: string;
}

export enum PartnerPayoutType {
    Any,
    Expense,
    Payout
}
export interface PartnerPayout {
    id: number;
    at: number;
    sum: number;
    notes?: string;
    partnerId: number;
    type: PartnerPayoutType;
}
export interface UserPayment extends Entity {
    id: number;
    uId: number;
    at: number;
    sum: number;
    initSum: number;
    trans: string;
    svc: PaymentServiceType;
    userName?: string;
    subs?: string;
}
export interface PartnerRef {
    id: number;
    uid: number;
    name: string;
    planId?: number;
}
export interface GetPartnerRefsOut {
    domain: string;
    defaultConfig?: string;
    defaultPlanId: number;
    partnerRefs: PartnerRef[];
    userPlans: UserPlan[];
    templates: string[];
}
export interface SearchOut<TItem> {
    items: TItem[];
    total: number;
    page: number;
}
export interface UsersOut extends SearchOut<User> {
}
export interface UserPaymentsOut extends SearchOut<UserPayment> {
    unpaidInvoices: number;
    paidInvoices: number;
    amountEur: number;
    amountUsd: number;
    amountUsdt: number;
    amount: number;
    lastPayoutAt: number;
}
export interface PartnerPayoutsOut extends SearchOut<PartnerPayout> {

}
export enum TickerFlags {
    None = 0,
    Smc = 1,
    Temp = 2,
    HasStartsFromDays = 4,
    Free = 8,
}
export enum TickerScanningStatus {
    Stopped,
    Idle,
    Running
}
export interface TickerScanInfo {
    status: string;
    statusId: TickerScanningStatus;
}
export interface AdminTickerInfo extends UserTickerInfo {
    internalId: string;
    internalName: string;
    flags: TickerFlags;
    allowScan: boolean;
    startsFrom: number;
}

export interface TickerStatus {
    id: string;
    scanInfo: TickerScanInfo;
    firstAt: number;
    lastAt: number;
    expired: boolean;
    buildDuration?: string;
}

export interface TickersStatusOut {
    tickers: TickerStatus[];
}
export interface UserTickersOut {
    tickers: AdminTickerInfo[];
    used: string[];
}

export interface TickersOut extends PageOut<AdminTickerInfo> {
}
export interface SearchTickersOut {
    tickers: AdminTickerInfo[];
}

export interface UpdateTickerIn {
    tid: string;
    flags?: TickerFlags;
    name?: string;
    desc?: string;
    digits?: number;
    startsFrom?: number;
    internalId?: string;
    internalName?: string;
    atrRatio?: number;
    serverId?: number;
}

export enum ExpirationTime {
    Minute,
    Hour,
    Day,
    Month
}

export interface ExchangeAsset extends NamedEntity {
}

export interface Exchange extends NamedEntity {
    canAdd: boolean;
}
export interface ExchangeInfoOut {
    assets: ExchangeAsset[];
    exchanges: Exchange[];
    servers: ServerNode[];
}

export interface getBarTimeIn {
    tid: string;
    tf: string;
    b: number;
}

export enum FixFieldType {
    Open,
    High,
    Low,
    Close
}
export enum FixValueType {
    Closest,
    Custom
}

export interface SmcSetting {
    id: number;
    field: SmcSettingField;
    value: number;
    asset?: TickerAssetType;
    tf?: number;
}

export enum SmcSettingField {
    Eq_Tol,
    Cascade_Tol,
    Reserved0,
    Reserved1,
    Eq_MaxBars_Between,
    Cascade_MaxBars_Between,
    MaAtr_Ratio,
    Ob_Engulf_MaxBars,
    Ob_Engulf_Size,
    Sb_Engulf_MaxBars,
    Sb_Engulf_Size,
    Tdp_MaxBars,
    Analytic_MinVolume
}

export interface KSettings {
    dev: number;
    eq: SmcSetting;
    cas: SmcSetting;
    ratio: SmcSetting;
    tickerRatio: number;
}

export interface TextTemplate {
    id: number;
    active: boolean;
    name: string;
    message: string;
    lang: LanguageType;
    subject?: string;
}

export enum ServerNodeType {
    Controller = 1,
    Alerts = 2,
    Tickers = 4,
    TickersFilter = 8,
    Signal = 16,
    Debug = 32,
    Trading = 64,
}
export interface ServerNode extends NamedEntity {
    notes?: string;
    type: ServerNodeType;
    active: boolean;
    host: string;
    internalHost?: string;
    tickersMultiplier: number;
}

export class ServerInfo {
    node: ServerNode;
    ver: string;
    usersAlertsThreads: number;
    tickersAlertsThreads: number;
    totalTempThreads: number;
    totalVitalThreads: number;
    maxTempThreads: number;
    maxVitalThreads: number;
    cpThreads: number;
    pooledThreads: number;
    queuedThreads: number;
}
export class ServersInfo {
    info: ServerInfo;
    servers: ServerNode[];
}
export enum PromoCampaignType {
    Extend = 1,
    SwitchPlan = 2,
    ExtendAndSwitchPlan = Extend | SwitchPlan
}
export interface PromoCampaign extends NamedEntity {
    uId: number;
    type: PromoCampaignType;
    duration: number;
    durationType: DurationType;
    planId?: number;
}

export interface Promo extends NamedEntity {
    camId: number;
    email?: string;
    at: number;
}
